import { ComponentType } from 'react';
import { connect } from 'react-redux';
import {
  getFaveCount,
  getIsFaveLoading,
  getIsFavourite,
} from '../CollectionPanel/redux/selectors';
import { changeFaveCustom } from '../CollectionPanel/redux/actionCreators';
import FaveButton, { Props } from './FaveButton';

export type StateProps = Pick<Props, 'isLoading' | 'isFavourite' | 'faveCount'>;
export type DispatchProps = Pick<Props, 'onChangeFave'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state, { deviation }: OwnProps): StateProps => ({
  isFavourite: getIsFavourite(state, deviation),
  faveCount: getFaveCount(state, deviation),
  isLoading: getIsFaveLoading(state, deviation),
});

const mapDispatchToProps: DispatchProps = {
  onChangeFave: changeFaveCustom,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FaveButton) as ComponentType<OwnProps>;
